import React from 'react';
import { Box, Typography } from '@mui/material';

const AlertTypes: React.FC = () => {
    const alertTypes = [
        'Drowsiness',
        'Distracted', 
        'Phone Calling',
        'Seat Belt',
        'Yawning',
        'Camera Block',
        'Forward Collision',
        'Harsh Acceleration',
        'Harsh Braking',
        'Over Speeding',
        'Unauthorized Driver',
        'Lane Departure',
        'Vulnerable Road User',
        'Harsh Turning',
        'Vehicle Idling',
        'SOS',
        'Cabin Occupancy'
    ];

    return (
        <Box className="flex flex-col border-b border-gray-200" id="alert-types">
            <Typography variant="h6" fontWeight={600} fontSize={16} mb={1}>
                ALERT TYPES
            </Typography>
            <Typography variant="body2" fontSize={14} fontWeight={400} mb={2}>
                When sending alert types in your JSON packet, use the following strings exactly as listed below. Each of these corresponds to a specific type of alert:
            </Typography>
            <Box sx={{ 
                backgroundColor: '#1e1e2e', 
                border: '1px solid #45475a',
                borderRadius: 2,
                overflow: 'hidden',
                marginBottom: 2 
            }}>
                <Box sx={{ 
                    backgroundColor: '#181825',
                    borderBottom: '1px solid #45475a',
                    px: 2,
                    py: 1
                }}>
                    <Typography 
                        variant="body2" 
                        fontSize={12}
                        sx={{ 
                            color: '#a6adc8',
                            fontWeight: 500
                        }}
                    >
                        ALERT TYPES LIST
                    </Typography>
                </Box>
                <Box sx={{ 
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    gap: 1,
                    padding: 2
                }}>
                    {alertTypes.map((alertType, index) => (
                        <Box 
                            key={index}
                            sx={{
                                backgroundColor: '#313244',
                                padding: '8px 12px',
                                borderRadius: '6px',
                                border: '1px solid #45475a',
                                '&:hover': {
                                    backgroundColor: '#383a59'
                                },
                                transition: 'background-color 0.2s ease'
                            }}
                        >
                            <Typography 
                                variant="body2" 
                                fontSize={12} 
                                sx={{ 
                                    color: '#8ac761ff',
                                    fontFamily: 'monospace',
                                    fontWeight: 500
                                }}
                            >
                                "{alertType}"
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    );
};
export default AlertTypes;
